import { HelpArticle } from "@/types/help.types.ts";
import { Avatar, Title, ButtonIcon, FontAwesomeIcon, Stack } from "@skailer-com/uikit";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";

interface Props {
  article: HelpArticle;
}
export const HelpArticleLink = ({ article }: Props) => {
  return (
    <Link to={`/help/article/${article.id}`}>
      <Stack
        direction={"horizontal"}
        justify={"between"}
        items={"start"}
        gap={"xl"}
        className={twMerge(
          "w-full bg-light rounded-lg p-4.5 hover:bg-dark/5 cursor-pointer h-full"
        )}
      >
        <Stack className={"flex flex-1 w-full"} direction={"horizontal"} items={"start"} gap={"md"}>
          {article.icon && (
            <Avatar
              size={"xl"}
              icon={
                <FontAwesomeIcon className={"text-secondary"} icon={`fa-light ${article.icon}`} />
              }
            />
          )}
          <Title header={article.title} caption={article.description} />
        </Stack>

        <ButtonIcon
          variant={"secondary"}
          icon={<FontAwesomeIcon icon={"fa-light fa-chevron-right"} />}
        />
      </Stack>
    </Link>
  );
};
